import React__default from 'react';

/**
 * Render a container wrapping the month grids.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Months(props) {
    return React__default.createElement("div", { ...props });
}

export { Months };
